import { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { AbsoluteRoute } from "../../core/routes";

import { CreateOrganizationAndLensSpacePageContainer } from "./CreateOrganizationAndLensSpacePage";

export const LensStudioCreateOrganizationAndLensSpace: FC = () => {
    const navigate = useNavigate();
    const goToLensStudioRedirect = useCallback(() => {
        navigate(AbsoluteRoute.LENS_STUDIO_REDIRECT);
    }, [navigate]);

    return (
        <CreateOrganizationAndLensSpacePageContainer
            onCreationSuccess={goToLensStudioRedirect}
            forceUseDefaultNames={true}
        />
    );
};
